"use client"
import { usePaginatedQuery } from "@blitzjs/rpc"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { useCallback, useState } from "react"
import { Button, DialogTrigger } from "react-aria-components"
import { Stack, StackRow } from "src/app/components/theme-grid"
import { ThemePopover } from "src/app/components/ReactAria"
import { NewGuide } from "src/app/guides/components/NewGuide"
import getGuides from "../queries/getGuides"
import { useSearchParams } from "next/navigation"
import { usePathname } from "next/navigation"
import { Route } from "next"

const ITEMS_PER_PAGE = 100

function GuideListCard(guide) {
  return <Link href={`/guides/${guide.id}`}>{guide.name}</Link>
}

export const GuidesListEdit = () => {
  const searchparams = useSearchParams()!
  const page = Number(searchparams.get("page")) || 0
  const [{ guides, hasMore }, { refetch }] = usePaginatedQuery(getGuides, {
    orderBy: { id: "asc" },
    skip: ITEMS_PER_PAGE * page,
    take: ITEMS_PER_PAGE,
  })
  const router = useRouter()
  const pathname = usePathname()
  const [createPopoverIsOpen, setCreatePopopverIsOpen] = useState(false)

  const onGuideCreate = useCallback(() => {
    setCreatePopopverIsOpen(false)
    refetch()
  }, [])

  const goToPreviousPage = () => {
    const params = new URLSearchParams(searchparams)
    params.set("page", (page - 1).toString())
    router.push((pathname + "?" + params.toString()) as Route)
  }
  const goToNextPage = () => {
    const params = new URLSearchParams(searchparams)
    params.set("page", (page + 1).toString())
    router.push((pathname + "?" + params.toString()) as Route)
  }

  return (
    <Stack gap={4} className="p-4 items-start">
      <DialogTrigger>
        <Button className="theme" onPress={() => setCreatePopopverIsOpen(true)}>
          create
        </Button>
        <ThemePopover isOpen={createPopoverIsOpen} onOpenChange={setCreatePopopverIsOpen}>
          <div className="bg-theme-color-background p-4">
            <NewGuide onCreate={onGuideCreate} />
          </div>
        </ThemePopover>
      </DialogTrigger>

      <StackRow nodeType="ul" gap4={true}>
        {guides.map((guide) => (
          <li key={guide.id}>
            <GuideListCard {...guide} />
          </li>
        ))}
      </StackRow>

      <StackRow gap4={true}>
        <button className="theme" disabled={page === 0} onClick={goToPreviousPage}>
          Previous
        </button>
        <button className="theme" disabled={!hasMore} onClick={goToNextPage}>
          Next
        </button>
      </StackRow>
    </Stack>
  )
}
